import React from 'react';

import { isMobile, useSoundWatcher } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';

import { WebGame } from '../webGame';
import { MobileGame } from '../mobileGame';
import { useVisibilityChange } from '../../hooks/useVisibilityChange';

const GameWebMobileContainer = observer(() => {
  useVisibilityChange();
  useSoundWatcher();
  return isMobile() ? <MobileGame /> : <WebGame />;
});

export default GameWebMobileContainer;
